import { render } from "./CZElectricityPrices.vue?vue&type=template&id=cb571ecc&ts=true"
import script from "./CZElectricityPrices.vue?vue&type=script&lang=ts"
export * from "./CZElectricityPrices.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__